'use strict';

var _ = require('lodash');
var FlightDataAdjustmentService = function FlightDataAdjustmentService() {
  function adjustData(overrideRows) {
    overrideRows.forEach(function (row) {
      row._old = row._old || {};
      resetAllocationTypeIfMinMaxHaveBeenCleared(row);
      setAllocationTypeIfNotDefined(row);
    });
  }
  function areUserMinMaxCleared(row) {
    return _.isNil(row.userMinAllocation) && _.isNil(row.userMaxAllocation);
  }
  function wereUserMinMaxSet(row) {
    return !_.isNil(row._old.userMinAllocation) && !_.isNil(row._old.userMaxAllocation);
  }
  function resetAllocationTypeIfMinMaxHaveBeenCleared(row) {
    if (areUserMinMaxCleared(row) && wereUserMinMaxSet(row)) {
      row._old.userAllocationType = row.userAllocationType;
      row.userAllocationType = null;
    }
  }

  // the undefined value in _old is important because without it we will not set the default allocation type ('A')
  function setAllocationTypeIfNotDefined(row) {
    var minMaxUserValuesDefined = !_.isNil(row.userMinAllocation) && !_.isNil(row.userMaxAllocation);
    var minMaxUserValuesWereModified = row._old.hasOwnProperty('userMinAllocation') || row._old.hasOwnProperty('userMaxAllocation');
    if (minMaxUserValuesDefined && minMaxUserValuesWereModified && _.isNil(row._old.userAllocationType)) {
      row._old.userAllocationType = undefined;
    }
  }
  return {
    adjustData: adjustData
  };
};
FlightDataAdjustmentService.$inject = [];
module.exports = FlightDataAdjustmentService;